module.exports = __webpack_public_path__ + "static/media/Elementos Web-02.599a4961.png";